module.exports = __webpack_public_path__ + "assets/static/jpg/charity_nbu.e057689b1a02dbb0541880fc4f6ba4f0.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/main/images/charity_nbu.jpg
 ** module id = 488
 ** module chunks = 1
 **/